import React from "react";
import './WorksTable.scss'

interface IWorksTableProps {
  data: App.IObject
}

export default class WorksTable extends React.Component<IWorksTableProps, any> {

  render() {
    return <div className='works-table'>
      <div>
        <h3>Замена</h3>
        <ul>
          {
            this.props.data['R'].map((element: App.IObject, index: number) => {
              return <li key={index}>
                <i className='fa fa-caret-right'/>
                &nbsp;{element.name}
              </li>
            })
          }
        </ul>
      </div>
      <div>
        <h3>Смазка</h3>
        <ul>
          {
            this.props.data['L'].map((element: App.IObject, index: number) => {
              return <li key={index}>
                <i className='fa fa-caret-right'/>
                &nbsp;{element.name}
              </li>
            })
          }
        </ul>
      </div>
      <div>
        <h3>Проверка</h3>
        <ul>
          {
            this.props.data['I'].map((element: App.IObject, index: number) => {
              return <li key={index}>
                <i className='fa fa-caret-right'/>
                &nbsp;{element.name}
              </li>
            })
          }
        </ul>
      </div>
    </div>
  }
}